"use client";

import Image from "next/image";
import type { ExcursionHero } from "@/(global)/excursions/slug-excursions";
import { excursionsCards } from "@/(global)/excursions/slug-excursions";
import Link from "next/link";

type Props = { hero: ExcursionHero; slug: string };

const HeroSection = ({ hero, slug }: Props): JSX.Element => {
  const cardMatch = excursionsCards.find(
    (c) => c.href === `/excursions/${slug}`,
  );
  const imageToUse = cardMatch?.image || hero.image;
  return (
    <section className="bg-white py-20 text-black md:py-24">
      <div className="mx-auto w-full max-w-[90rem] px-6 md:px-8">
        <div className="text-center">
          <h1 className="font-space-age text-3xl tracking-[0.18em] md:text-5xl lg:text-6xl">
            {hero.title}
          </h1>
          {hero.subtitle && (
            <p className="mt-4 text-base text-black/80 md:text-lg">
              {hero.subtitle}
            </p>
          )}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              href={hero.ctaPrimaryHref}
              className="inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-semibold text-black shadow-sm transition hover:bg-gold-600"
            >
              {hero.ctaPrimaryLabel}
            </Link>
            {hero.ctaSecondaryHref && hero.ctaSecondaryLabel && (
              <Link
                href={hero.ctaSecondaryHref}
                className="inline-flex items-center justify-center rounded-full border border-black/20 px-6 py-3 text-sm font-semibold text-black transition hover:bg-black/5"
              >
                {hero.ctaSecondaryLabel}
              </Link>
            )}
          </div>
        </div>

        {imageToUse && (
          <div className="relative mx-auto mt-10 aspect-[16/9] min-h-[42vh] w-full max-w-6xl shadow-2xl shadow-black/20 md:min-h-[56vh]">
            <Image
              src={imageToUse}
              alt={hero.imageAlt || hero.title}
              fill
              className="object-cover"
              priority
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
